
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "SeoTagsImageBlock",

  computed: {
    localValues: function () {
      return this.externalData?.SeoTagsImageBlock || this.values || {}
    },

    tagsList: function () {
      if ((this.values?.tags || []).length > 0) {
        return this.values?.tags
      }
      if ((this.externalData?.SeoTagsImageBlock?.tags || []).length > 0) {
        return this.externalData?.SeoTagsImageBlock?.tags
      }

      return []
    },

    useH1: function () {
      return this.cfgs?.title_h1 || false
    }
  }
})
